import glamorous from 'glamorous'
import { propsToHelperClasses } from '../helpers'

const Image = glamorous.div('image', propsToHelperClasses)

export default Image
